// extracted by mini-css-extract-plugin
export default {"container":"_1W5CRnVt","bodyScrollDisabled":"JuTPKM3t","unconstrainedHeight":"NiRhG5E-","overflowVisible":"_2ZFW_0ZZ","roundedCorners":"UxpasYM2"};